import SmarterChat from "@/components/SmarterChat/Component";
import HeaderButton from "@/components/SmarterChat/HeaderButton";

export { HeaderButton };
export type { HeaderButtonProps } from "@/components/SmarterChat/HeaderButton";
export default SmarterChat;
